// @ts-nocheck
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { socket } from "../../../services/socket.io/socket.io.config";
import { NEW_CHAT_SETUP } from "./constants";
import {
  NEW_CHAT_SETUP_LOADING,
  NEW_CHAT_SETUP_SUCCESS,
  NEW_CHAT_SETUP_FAILURE
} from "../../../store/constants/noteoneononemessaging";
import { emitSocketEvent } from "../../../services/apiService";

const useNoteOneOnOneSetupEvents = () => {
  const dispatch = useDispatch();
  const auth = useSelector((store) => store.auth);
  const newchatsetupHandler = async () => {
    try {
      const response = await emitSocketEvent({
        event: NEW_CHAT_SETUP,
        payload: {
          _id: auth?.userId
        }
      });
      if (response?.status === "ok") {
        dispatch({
          type: NEW_CHAT_SETUP_SUCCESS
        });
      } else {
        dispatch({
          type: NEW_CHAT_SETUP_FAILURE
        });
      }
    } catch (error) {
      console.error("NEW_CHAT_SETUP_ERROR:", error);
    }
  };
  React.useEffect(() => {
    dispatch({
      type: NEW_CHAT_SETUP_LOADING
    });
    if (socket.connected) {
      newchatsetupHandler();
    } else {
      socket.on("connect", () => {
        newchatsetupHandler();
      });
    }
    socket.on("connect_error", () => {});
  }, []);
  return {};
};
export default useNoteOneOnOneSetupEvents;